<div class="gs-dialog" (keydown)="onKeydown($event)">
  <!-- Campo di ricerca -->
  <div class="gs-input-row">
    <mat-icon class="gs-search-icon">search</mat-icon>
    <input
      #searchInput
      matInput
      type="text"
      class="gs-input"
      [formControl]="searchControl"
      placeholder="Cerca pagine, azioni, fatture, clienti…"
      autocomplete="off"
      cdkFocusInitial
    />
    @if (loading()) {
      <mat-spinner class="gs-spinner" diameter="20"></mat-spinner>
    }
    @if (hasQuery()) {
      <button
        mat-icon-button
        class="gs-clear"
        aria-label="Cancella ricerca"
        (click)="clear()"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <!-- Risultati -->
  <div class="gs-results">
    @for (group of groups(); track group.label) {
      <div class="gs-group">
        <div class="gs-group-header">{{ group.label }}</div>
        @for (item of group.items; track item.index) {
          <button
            type="button"
            class="gs-item"
            [class.active]="item.index === activeIndex()"
            (click)="execute(item.result)"
            (mouseenter)="setActive(item.index)"
          >
            <mat-icon class="gs-item-icon">{{ item.result.icon }}</mat-icon>
            <span class="gs-item-text">
              <span class="gs-item-title">{{ item.result.title }}</span>
              @if (item.result.subtitle) {
                <span class="gs-item-subtitle">{{ item.result.subtitle }}</span>
              }
            </span>
          </button>
        }
      </div>
    }

    @if (!hasResults() && !loading()) {
      <div class="gs-empty">
        <mat-icon>search_off</mat-icon>
        <span>Nessun risultato</span>
      </div>
    }
  </div>

  <!-- Barra suggerimenti tastiera -->
  <div class="gs-footer">
    <span><kbd>↑</kbd><kbd>↓</kbd> per navigare</span>
    <span><kbd>↵</kbd> per aprire</span>
    <span><kbd>esc</kbd> per chiudere</span>
  </div>
</div>
